/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UpdateColumnConfigRequest
 */
export interface UpdateColumnConfigRequest {
  /**
   *
   * @type {string}
   * @memberof UpdateColumnConfigRequest
   */
  companyListId: string;
  /**
   *
   * @type {string}
   * @memberof UpdateColumnConfigRequest
   */
  columnConfig: string;
}

/**
 * Check if a given object implements the UpdateColumnConfigRequest interface.
 */
export function instanceOfUpdateColumnConfigRequest(
  value: object,
): value is UpdateColumnConfigRequest {
  if (!("companyListId" in value) || value["companyListId"] === undefined)
    return false;
  if (!("columnConfig" in value) || value["columnConfig"] === undefined)
    return false;
  return true;
}

export function UpdateColumnConfigRequestFromJSON(
  json: any,
): UpdateColumnConfigRequest {
  return UpdateColumnConfigRequestFromJSONTyped(json, false);
}

export function UpdateColumnConfigRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): UpdateColumnConfigRequest {
  if (json == null) {
    return json;
  }
  return {
    companyListId: json["companyListId"],
    columnConfig: json["columnConfig"],
  };
}

export function UpdateColumnConfigRequestToJSON(
  json: any,
): UpdateColumnConfigRequest {
  return UpdateColumnConfigRequestToJSONTyped(json, false);
}

export function UpdateColumnConfigRequestToJSONTyped(
  value?: UpdateColumnConfigRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyListId: value["companyListId"],
    columnConfig: value["columnConfig"],
  };
}
